module.exports = __webpack_public_path__ + "595b8a6def84d428aa1cd2dcead40e61.png";